import { Directive, Input } from "@angular/core";
import { NG_VALIDATORS, Validator, AbstractControl } from "@angular/forms";
import * as moment from "moment";

@Directive({
  selector: "[afterDate]",
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: AfterDateValidatorDirective,
      multi: true
    }
  ]
})
export class AfterDateValidatorDirective implements Validator {
  @Input("afterDate") after: Date | string;

  validate(control: AbstractControl): { [key: string]: any } | null {
    if (!control.value) return null;
    return moment(control.value).isValid() &&
      moment(this.after).isValid() &&
      moment(control.value).isSameOrAfter(this.after)
      ? null
      : { afterDate: { value: control.value } };
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/afterdatevalidator.directive.ts